export const GITHUB_ACCESS_TOKEN_COOKIE = 'x-github-access-token';
export const GITHUB_INSTALLATION_ID_COOKIE = 'github_installation_id';
export const GITHUB_TOKEN_TYPE_COOKIE = 'github_token_type';
